exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#kirmizi,#mavi,#sari,#turuncu,#yesil{border-radius:15px 50px;text-align:center;font-size:25px}#pid1:hover,#pid2:hover,#pid3:hover,#pid4:hover{border-radius:15px 50px;background-color:#63ca92;text-align:center;font-size:25px}.searchCss{border-radius:6px;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-513a7369","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Students.vue
// module id = 139
// module chunks = 0